export default __webpack_public_path__ + "static/media/bulldog-2.f3241a5e.png";